const CHATBOT_URL = '_exclusive/helps/chatbots';

/**
 * Verify Topup Payment Proofs
 * https://blueprint.bukalapak.io/exclusive/t/helps~help~chatbots~post~exclusive~helps~chatbots~topup-payment-proofs
 * @param {object} body - { image_url: <string>, image_base64: <string> }
 * @returns {Promise}
 */
export const verifyTopupPaymentProofs = ($axios, body = {}) =>
  $axios.$post(`${CHATBOT_URL}/topup-payment-proofs`, body);

/**
 * Verify Qris Payment Proofs
 * https://blueprint.bukalapak.io/exclusive/t/helps~help~chatbots~post~exclusive~helps~chatbots~qris-payment-proofs
 * @param {object[]} body - { image_url: <string>, image_base64: <string> }
 * @returns {Promise}
 */
export const verifyQrisPaymentProof = ($axios, body = {}) => $axios.$post(`${CHATBOT_URL}/qris-payment-proofs`, body);

/**
 * Verify user identities and automatically change phone number if the data is successfully verified
 * https://blueprint.bukalapak.io/exclusive/t/helps~help~chatbots~post~exclusive~helps~chatbots~identity-proofs
 * @param {object} body - { identity_card_image: <string>, self_portrait_image: <string>, supporting_document_image: <string>, new_phone_number: <string> }
 * @returns {Promise}
 */
export const changePhoneNumberUsingIdentityProofs = ($axios, body = {}) =>
  $axios.$post(`${CHATBOT_URL}/identity-proofs`, body);
